import React, { useMemo } from "react";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { usePageContext } from "vike-react/usePageContext";

const BREADCRUMB_MAP = {
  "/operators": { main: "Операторы", inner: "Все операторы" },
  "/operators/add": { main: "Операторы", inner: "Добавить оператора" },
  "/teams": { main: "Бригады", inner: "Все бригады" },
  "/teams/add": { main: "Бригады", inner: "Добавить бригаду" },
  "/teams/:id/edit": { main: "Бригады", inner: "Редактировать бригаду" },
  "/applications": { main: "Заявки", inner: "Все заявки" },
  "/applications/add": { main: "Заявки", inner: "Добавить заявку" },
  "/applications/events": { main: "Заявки", inner: "История изменений" },
  "/reports": { main: "Отчёты", inner: "Отчеты по заявкам" },
  "/reports/operators": { main: "Отчёты", inner: "Отчеты по операторам" },
};

export const Breadcrumbs: React.FC = () => {
  const { urlPathname } = usePageContext();

  const { mainPage, innerPage, rootPathname } = useMemo(() => {
    const normalizedPath = urlPathname.replace(/\/teams\/[^/]+\/edit/, "/teams/:id/edit");

    const matchedRoute =
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      BREADCRUMB_MAP[normalizedPath] || Object.entries(BREADCRUMB_MAP).find(([key]) => normalizedPath.startsWith(key))?.[1];

    return {
      mainPage: matchedRoute?.main || "",
      innerPage: matchedRoute?.inner || "",
      rootPathname: `/${urlPathname.split("/")[1]}`,
    };
  }, [urlPathname]);

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {mainPage && (
          <>
            <BreadcrumbItem className="hidden md:block">
              <BreadcrumbLink href={rootPathname}>{mainPage}</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="hidden md:block" />
          </>
        )}
        <BreadcrumbItem>
          <BreadcrumbPage>{innerPage}</BreadcrumbPage>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  );
};
